import { z, isoZ } from 'my-zod'
import { ActionPlanStatusTypeEnum } from './action-plan-enums'

export const actionPlanModel = z.object({
  id: z.number(),
  shortId: z.string(),
  actionPlanTriggerId: z.number().nullable(),
  creatingUserId: z.number(),
  ownerUserId: z.number().setLabel('Action Plan Owner'),
  outfitterId: z.number().nullable().setLabel('Outfitter'),
  dueDate: isoZ.date(),
  title: z.string().nonempty().setLabel('Action Plan Name'),
  description: z.string().nullable(),
  status: ActionPlanStatusTypeEnum,
  lastModifiedDate: isoZ.instant(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type actionPlanModel = z.infer<typeof actionPlanModel>
